<template>
  <canvas id="bg"></canvas>
</template>

<script src="./logo-box.ts"></script>
<style src="./logo-box.scss" lang="scss"></style>
